import { FC, useMemo } from "react"
import clsx from "clsx"
import styles from "./DirectoryObject.module.scss"

interface Props {
  className?: string
  onClick?: any
  searchStr?: string
  name: string
  path: string
  id: string
}

const DirectoryObject: FC<Props> = ({ className, onClick, searchStr, id, name, path }) => {
  const objName = useMemo(() => {
    if (!searchStr) return name
    const currentSearch = searchStr.toLowerCase()
    const index = name.toLowerCase().indexOf(currentSearch)
    let searchedName = name
    if (index >= 0) {
      searchedName =
        searchedName.substring(0, index) +
        `<span class=${styles.highlight}>` +
        searchedName.substring(index, index + currentSearch.length) +
        "</span>" +
        searchedName.substring(index + currentSearch.length)
      return searchedName
    } else {
      return name
    }
  }, [name, searchStr])

  const objPath = useMemo(() => {
    if (!searchStr) return path
    const currentSearch = searchStr.toLowerCase()
    const index = path.toLowerCase().indexOf(currentSearch)
    let searchedName = path
    if (index >= 0) {
      searchedName =
        searchedName.substring(0, index) +
        `<span class=${styles.highlight}>` +
        searchedName.substring(index, index + currentSearch.length) +
        "</span>" +
        searchedName.substring(index + currentSearch.length)
      return searchedName
    } else {
      return path
    }
  }, [path, searchStr])

  return (
    <div
      className={clsx(styles.item, className)}
      onClick={() => {
        if (onClick) onClick(id, name, path)
      }}
    >
      <div className={styles.content}>
        <p className={styles.name} dangerouslySetInnerHTML={{ __html: objName }} />
        <p className={styles.path} dangerouslySetInnerHTML={{ __html: objPath }} />
      </div>
    </div>
  )
}

export default DirectoryObject
